import { render, staticRenderFns } from "./contactCenSqzxOne.vue?vue&type=template&id=273580c4&scoped=true"
import script from "./contactCenSqzxOne.vue?vue&type=script&lang=js"
export * from "./contactCenSqzxOne.vue?vue&type=script&lang=js"
import style1 from "./contactCenSqzxOne.vue?vue&type=style&index=1&id=273580c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273580c4",
  null
  
)

export default component.exports